<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { fly } from "svelte/transition";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let retailer: {
    address1: string;
    address2: string;
    city: string;
    name: string;
    state: string;
    zip: string;
  };
  export let showUnselect: boolean = true;

  let address = [
    [retailer.address1, retailer.address2]
      .filter(deliveryAddressLineElements => !!deliveryAddressLineElements)
      .join(" "),
    [retailer.city, retailer.state, retailer.zip]
      .filter(lastLineElements => !!lastLineElements)
      .join(" "),
  ]
    .filter(standardizedAddressElements => !!standardizedAddressElements)
    .join(", ");

  const dispatch = createEventDispatcher();

  const unselect = (_e: Event) => dispatch("unselected");

</script>

<div class="fizz-bordered fizz-inset-square-16" in:fly>
  <div class="fizz-flex-row-8">
    <div class="fizz-inset-square-12 fizz-surface-blue fizz-radius-medium fizz-text-brand">
      <Icon type="Storefront" extraClassNames="fizz-icon-24" />
    </div>
    <div class="fizz-flex-item">
      <p class="fizz-text-strong">{retailer.name}</p>
      <p>{address}</p>
    </div>
    {#if showUnselect}
      <div class="fizz-flex-no-shrink">
        <button
          on:click={unselect}
          class="fizz-inset-square-8 fizz-radius-small fizz-text-subdued"
          data-testid="unselect"
          type="button"
        >
          <Icon type="X" extraClassNames="fizz-icon-12" />
        </button>
      </div>
    {/if}
  </div>
</div>
